var cov_1n3vo58jce = function () {
  var path = "/Users/spana/SHEIN/shineout/src/InputTitle/styles/index.js",
      hash = "37f525b6a41ea6d5f17ce631ca9fd3d32fb7916d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/InputTitle/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 31
        },
        end: {
          line: 4,
          column: 76
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var inputTitleLess = {};
import genaration from '../../utils/classname';
export var inputTitleClass = (cov_1n3vo58jce.s[0]++, genaration(inputTitleLess, 'input-title-box'));